import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {replaceItem, removeItem} from '../../common/util/array';

const INITIAL_STATE = {
  'editing': false,
  'loading': false,
  'loadingLine': false,
  'isSpecial': false,
  'selectedOrder': null,
  'orderToDelete': null,
  'indexToDelete': null,
  'selectedRow': null,
  'origin': '',
  'list': [],
};

const BASE_ELEMENT = {
  'active': true,
  'isNew': true,
  'partCode': '',
  'partQuantity': 1,
  'partProcessedQuantity': 0,
};

const addNewRow = (editing, list, selectedOrder) => {
  if (editing) {
    return list;
  }

  return [...list, {...BASE_ELEMENT, 'orderCode': selectedOrder.orderCode}];
};

const setRowEditable = (orders, index) => {
  const rowToEdit = {...orders[index], 'active': true};

  return {
    'editing': true,
    'list': replaceItem(orders, index, rowToEdit),
    'selectedRow': orders[index],
  };
};

const getOldCode = (currentCode, oldCode) => {
  return !oldCode ? currentCode : oldCode;
};

const updateRowValue = (orders, {index, field, value}) => {
  const rowToEdit = {
    ...orders[index],
    [field]: value,
    'oldPartCode': getOldCode(orders[index].partCode, orders[index].oldPartCode),
  };
  return replaceItem(orders, index, rowToEdit);
};

const updateProcessedRow = (orders, index) => {
  const updatedRow = {
    ...orders[index],
    'active': false,
    'oldPartCode': null,
    'isNew': false,
  };

  return replaceItem(orders, index, updatedRow);
};

const updateCheckedRow = (orders, response, {order, type}) => {
  if (typeof type !== 'number' || !orders[type]) {
    return orders;
  }

  return replaceItem(orders, type, {
    ...order,
    'description': response.data.name,
  });
};

export const providersOrdersManagementDetail = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_SELECTED_PROVIDER_ORDER_DETAIL]: (state, action) => {
      return INITIAL_STATE;
    },
    [ActionTypes.VIEW_PROVIDER_ORDER_DETAIL]: (state, action) => ({
      ...state,
      'selectedOrder': action.payload,
    }),
    [ActionTypes.ADD_ELEMENT_TO_PROVIDER_ORDER_DETAIL]: (state, action) => ({
      ...state,
      'editing': true,
      'list': addNewRow(state.editing, state.list, state.selectedOrder),
    }),
    [ActionTypes.REMOVE_ELEMENT_FROM_PROVIDER_ORDER_DETAIL]: (
      state,
      action
    ) => ({
      ...state,
      'editing': false,
      'list': removeItem(state.list, action.payload),
    }),
    [ActionTypes.CHANGE_PROVIDER_DETAIL_ELEMENT]: (state, action) => ({
      ...state,
      'list': updateRowValue(state.list, action.payload),
    }),
    [ActionTypes.EDIT_ELEMENT_IN_PROVIDER_ORDER_DETAIL]: (state, action) => ({
      ...state,
      ...setRowEditable(state.list, action.payload),
    }),
    [ActionTypes.SELECT_PROVIDER_ORDER_DETAIL_ELEMENT]: (state, action) => ({
      ...state,
      'orderToDelete': state.list[action.payload],
      'indexToDelete': action.payload,
    }),
    [ActionTypes.CLEAR_SELECTED_PROVIDER_ORDER_DETAIL_ELEMENT]: (
      state,
      action
    ) => ({
      ...state,
      'orderToDelete': null,
      'indexToDelete': null,
    }),
    [ActionTypes.CANCEL_PROVIDER_ORDER_ELEMENT_EDITION]: (state, action) => ({
      ...state,
      'editing': false,
      'list': replaceItem(state.list, action.payload, state.selectedRow),
      'selectedRow': null,
    }),
    [ActionTypes.GET_PROVIDER_ORDER_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'editing': false,
    }),
    [ActionTypes.GET_PROVIDER_ORDER_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'origin': action.response.origin,
      'isSpecial': action.response.isSpecial,
    }),
    [ActionTypes.GET_PROVIDER_ORDER_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'origin': '',
      'isSpecial': false,
    }),
    [ActionTypes.EDIT_PROVIDER_ORDER_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.EDIT_PROVIDER_ORDER_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'editing': false,
      'list': updateProcessedRow(state.list, action.payload),
    }),
    [ActionTypes.EDIT_PROVIDER_ORDER_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETE_PROVIDER_ORDER_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETE_PROVIDER_ORDER_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': removeItem(state.list, action.payload),
    }),
    [ActionTypes.DELETE_PROVIDER_ORDER_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.ADD_PROVIDER_ORDER_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.ADD_PROVIDER_ORDER_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'editing': false,
      'list': updateProcessedRow(state.list, action.payload),
    }),
    [ActionTypes.ADD_PROVIDER_ORDER_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': updateCheckedRow(state.list, action.response, action.payload),
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
